"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getStoreAndRoutes;
var _reactRouterRedux = require("react-router-redux");
var _configureStore = _interopRequireDefault(require("./configureStore"));
/* eslint max-params: 0 */ // this is ok for internal methods
function getStoreAndRoutes(initialState, createRoutes, historyType, historySyncOptions) {
  var injectors = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var pageProps = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  // Injection point: beforePageMounted
  injectors.filter(function (injector) {
    return injector.beforePageMounted;
  }).forEach(function (injector) {
    return injector.beforePageMounted(pageProps);
  });

  // Configure store (injectors are called in this function)
  var store = (0, _configureStore["default"])({
    initialState: initialState,
    middleware: [(0, _reactRouterRedux.routerMiddleware)(historyType)]
  }, injectors, pageProps);

  // Create history by syncing with the redux store
  var history = (0, _reactRouterRedux.syncHistoryWithStore)(historyType, store, historySyncOptions);

  // Injection point: beforeCreateRoutes
  injectors.filter(function (injector) {
    return injector.beforeCreateRoutes;
  }).forEach(function (injector) {
    return injector.beforeCreateRoutes(pageProps);
  });

  // Create routes
  var routes = createRoutes(store.getState, store.dispatch);

  // Injection point: afterCreateRoutes
  injectors.filter(function (injector) {
    return injector.afterCreateRoutes;
  }).forEach(function (injector) {
    return injector.afterCreateRoutes(routes, pageProps);
  });
  return {
    store: store,
    routes: routes,
    history: history
  };
}
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/thunderball-client/lib/render/getStoreAndRoutes.js
// module id = 3156
// module chunks = 25